import { useAddIncident } from '../../../state/incidents';
import { newRowIncidentState } from './atoms';
import { DEFAULT_PREPARED_INCIDENT } from './constants';

export const useIncidentInlineAddingParams = {
  newEntityAtom: newRowIncidentState,
  useAddEntity: useAddIncident,
  defaultPreparedEntity: DEFAULT_PREPARED_INCIDENT,
};
